// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__EWzFU","inner":"Footer_inner__sgkjX","nextIcon":"Footer_nextIcon__3UO0Q","innerLeft":"Footer_innerLeft__8S0_8"};